/**
 * @file FormExchange
 */
'use strict';

/**
 * @classname FormExchange
 * @classdesc 
 */
export default class FormExchange {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller) {
		this._controller = controller;
	};

	/**
	 * フォーム送信前処理
	 *
	 * @memberof FormExchange
	 * @return {undefined}
	 */
	preProcessing($form) {
		console.log(`${this.constructor.name}.preProcessing`);

		console.log($('#title').val());
		console.log($('#content').val());
		console.log($('#sent_at').val());
		console.log($('#target_type').val());
		console.log($('#target_member_type').val());

		$('#test_title').val($('#title').val());
		$('#test_content').val($('#content').val());
		$('#test_sent_at').val($('#sent_at').val());
		$('#test_target_type').val($('#target_type').val());
		$('#test_target_member_type').val($('#target_member_type').val());

		// バリデーション前に行う処理を記載（終了）
		this._controller.completePreProcessing($form);
	};
}
